import SyncSegmentsForm from './SyncSegmentsForm';

const SyncSegmentsNewForm = () => {
  return (
    <>
      <SyncSegmentsForm
        segmentSync={{
          name: 'New segment sync',
          type: null,
          segmentId: null,
          running: false,
          adAccountId: null,
          ratio: 3,
        }}
      />
    </>
  );
};

export default SyncSegmentsNewForm;
